/** RFQ status chip / accent colors — soft pastel bg + matching dark text. */
export const RFQ_STATUS_COLORS = {
  NEW: { backgroundColor: '#FFF4E5', color: '#B75B00' },
  IN_PROGRESS: { backgroundColor: '#EAF2FF', color: '#175CD3' },
  BOOKING_INITIATED: { backgroundColor: '#EAF2FF', color: '#175CD3' },
  CONVERTED: { backgroundColor: '#E8F7EE', color: '#16794A' },
  LOST: { backgroundColor: '#FDECEC', color: '#C43232' },
} as const;

export type RfqStatusKey = keyof typeof RFQ_STATUS_COLORS;

export const getRfqStatusColors = (status?: string | null) => {
  const key = String(status || '').toUpperCase() as RfqStatusKey;
  return RFQ_STATUS_COLORS[key] || null;
};
